import { useEffect } from "react";

export default function Seo({ title, description, path = "" }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", `https://kratosventuregroup.com${path}`);
  }, [title, description, path]);
  return null;
}
